module.exports = __webpack_public_path__ + "img/icon-person.1b50b171.svg";